<template>
  <div class="flex flex-row w-full">
    <div class="flex-1">
      <el-date-picker
          class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
          v-model="option.date"
          type="date"
          :picker-options="dateRangeOptions"
          placeholder="dd-mm-aaaa">
        </el-date-picker>
    </div>
    <div class="focus:outline-none group flex flex-none items-center">
      <base-icon v-if="option.icon" :name="option.icon" class="mr-2 ml-2" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'calendar-icon-item',
  data () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
    }
  },
  props: {
    option: {
      type: [Array, Object],
      required: true
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  computed: {
    setTheme: function () {
      return {
        'bg-white hover:bg-primary-50 hover:text-primary active:bg-primary-100':
          this.theme === 'light',
        'bg-secondary text-white hover:bg-secondary-900 active:bg-secondary focus:bg-secondary-900':
          this.theme === 'dark'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
